<template>
  <div class="cookie-notify">
    <div class="cookie-close" @click="$emit('close')" />
    <div class="cookie-text">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'CookieNotifier',
};
</script>
<style scoped>
.cookie-notify {
  box-sizing: border-box;
  position: absolute;
  z-index: 5;
  bottom: 24px;
  left: 24px;
  width: 256px;
  padding: 24px 16px 16px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 10px 30px rgba(120, 131, 152, 0.48);
  left: 50%;
  transform: translateX(-50%);
}
.cookie-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 36px;
  height: 36px;
  background-image: url(~IMAGES/icons/close.svg);
  background-size: 16px;
  background-position: center;
  cursor: pointer;
  transition: 0.4s;
}
.cookie-close:hover {
  transform: rotate(90deg);
}
.cookie-text {
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 10px;
}
@media (--viewport-planshet) {
  .cookie-notify {
    left: 24px;
    position: fixed;
    transform: translate(0, 0);
  }
}
</style>
